// THIS TYPE WAS AUTOGENERATED
/// <reference path="Domain.ts" />
module AI
{
"use strict";
    export class EventData extends Microsoft.Telemetry.Domain
    {
        public ver: number;
        public name: string;
        public properties: any;
        public measurements: any;
        
        constructor()
        {
            super();

            this.ver = 2;
            this.properties = {};
            this.measurements = {};
            
            super();
        }
    }
}
